module.exports = __webpack_public_path__ + "static/img/about_11.11a59a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_11.png
// module id = PxFP
// module chunks = 1